import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13877386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout-left" }
const _hoisted_3 = { class: "layout-right" }
const _hoisted_4 = { class: "layout-right-top" }
const _hoisted_5 = { class: "layout-right-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_top_nav = _resolveComponent("top-nav")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_top_nav)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, { include: ['search', 'manga-list', 'chapter-list'] }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024 /* DYNAMIC_SLOTS */))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}